// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"439b4da9","163":"51b39484","550":"bf6b6676","565":"a883f417","903":"9bad4a3a"}[chunkId] + ".chunk.js";
};